export default __webpack_public_path__ + "static/media/Exclusive 2-Week Luggage Deals_0511_1811_2025.497be192.xlsx";